/** The tabs of «تنظیمات کسب‌وکار» that online payment, buyer links, the wallet and the business services link to. */
export type BusinessSettingsTab =
  | 'online-payment'
  | 'buyer-links'
  | 'wallet'
  | 'invoice-alerts'
  | 'tax-workspace'
  | 'tax-workspace-alerts'
  | 'notification-sms'
  | 'users'
  | 'responsibilities'
  | 'services-setup'
  | 'service-packages'
  | 'services-overview'

const BUSINESS_SETTINGS_ROOT = '/apps/taxpayer-management/setting'

/** «تنظیمات کسب‌وکار» of a business, on the tab its page opens with. */
export const businessSettingsRootPath = (companyId: number) =>
  `${BUSINESS_SETTINGS_ROOT}/${companyId}`

/**
 * «تنظیمات کسب‌وکار ← <tab>» of a business: TaxpayersPage's `setting/:companyId/*`. Every link into these tabs is
 * built here; `companies/{id}/…` matches no route and opened an empty page (found 2026-10-15). The periodic reports
 * left these tabs for «گزارش‌ها»: business-services/core/periodicReportsPath.
 */
export const businessSettingsPath = (companyId: number, tab: BusinessSettingsTab) =>
  `${businessSettingsRootPath(companyId)}/${tab}`
